/**
 * The backend refuses recording consent and a bot fallback until the tenant has saved its recording
 * settings once: they fix how long recordings and bot transcripts are kept.
 */
export const RECORDING_SETTINGS_REQUIRED_ERROR_CODE = 'DMS-TE-RC-0005';
